export default __webpack_public_path__ + "images/0x5c09a9ce08c4b332ef1cc5f7cadb1158c32767ce.png";